import { Modal, ModalOverlay, type ModalOverlayProps } from '@launchpad-ui/components';

import styles from './command-palette-modal.module.css';

export interface CommandPaletteModalProps extends ModalOverlayProps {}

export function CommandPaletteModal({ children, ...props }: CommandPaletteModalProps) {
  return (
    <ModalOverlay isKeyboardDismissDisabled {...props} className={styles.overlay}>
      <Modal className={styles.modal}>{children}</Modal>
    </ModalOverlay>
  );
}
